import { User } from '@/domain/entities/user.entity';
import { apiClient } from '@/data/api/axios-client';

/**
 * Functional user repository.
 * Supports both real API and mock data via parameter.
 */
export const userRepository = {
    getUsers: async (useMock: boolean = false): Promise<User[]> => {
        if (useMock) {
            return []; // Placeholder for mock users
        }
        const response = await apiClient.get<any[]>('/users');
        return response;
    },

    getUserById: async (id: string, useMock: boolean = false): Promise<User> => {
        if (useMock) {
            // Placeholder for mock user
            return {} as User;
        }
        const response = await apiClient.get<any>(`/users/${id}`);
        return response;
    },
};
